import { Component, computed, inject, input } from '@angular/core';

import { MyBetsEventModel } from '../../../models/my-bets-event.model';
import { MyBetsUtilService } from '../../../services/my-bets-util.service';
import { MyBetsEventGridScoreboardComponent } from '../my-bets-event-grid-scoreboard/my-bets-event-grid-scoreboard.component';
import { MyBetsScoreboardComponent } from '../my-bets-scoreboard.component';

@Component({
    selector: 'ms-my-bets-scoreboard-wrapper',
    imports: [MyBetsScoreboardComponent, MyBetsEventGridScoreboardComponent],
    templateUrl: './my-bets-scoreboard-wrapper.component.html',
})
export class MyBetsScoreboardWrapperComponent {
    private myBetsUtilService = inject(MyBetsUtilService);
    event = input.required<MyBetsEventModel>();
    isGridScoreboardEnabled = computed(() => this.myBetsUtilService.isGridScoreboardEnabled(this.event()));
}
